import { jsx as _jsx } from "react/jsx-runtime";
import { FormField } from "../../components/Form";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { DateDropdown } from "../DateDropdown";
import { DateInputs } from "../DateInputs/DateInputs";
export const DateOfBirthFormProvider = (props) => {
    const { dobFormType } = useConfig();
    const { __ } = useTranslations();
    return (_jsx(FormField, { name: props.fieldName, id: "dobLabelId", label: __("auth.registration.dob.title"), render: ({ field }) => dobFormType === "inputs" || dobFormType === "inputs_reversed" ? (_jsx(DateInputs, { ...props, ...field })) : (_jsx(DateDropdown, { ...props, ...field, dropdownFieldPrefix: props.fieldsPrefix })), validation: {
            required: __("form_validation.field_required"),
        } }));
};
//# sourceMappingURL=DateOfBirthFormProvider.js.map